import { Alert, Box, CircularProgress, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { emailValidation } from '../../../../../redux/auth/actions';
import { useAppDispatch } from '../../../../../redux/store.model';
import { useShowErrorMessage } from '../../../../../handlingErrors';
import { getPolyglot } from '../../../../../i18n';
import AuthLayout, {
  HeaderIcon,
} from '../../../../../components/auth/AuthLayout';
import SC_background from '../../../assets/scc_login_image.jpg';

export const ValidateEmail = () => {
  const dispatch = useAppDispatch();
  const params = useParams();
  const [searchParams] = useSearchParams();

  const token = searchParams.get('token');
  const workspaceId = params.workspaceId;

  const polyglot = getPolyglot();
  const showError = useShowErrorMessage();
  const [message, setMessage] = useState('register.loading_email_validation');

  useEffect(() => {
    const validateUserEmail = async () => {
      if (!token || !workspaceId) {
        setMessage('register.error.email_validation');
        return;
      }

      try {
        await dispatch(emailValidation(token, workspaceId));
        setMessage('register.email_validation_success');
      } catch (error) {
        showError(polyglot.t('register.error.email_validation'));
        setMessage('register.email_validation_error');
      }
    };

    validateUserEmail();
  }, [dispatch, token, workspaceId]);

  return (
    <AuthLayout imageRight={SC_background}>
      <Box margin={2}>
        <Alert
          icon={<HeaderIcon />}
          severity="info"
          sx={{ flexDirection: 'column' }}
        >
          <Typography variant="subtitle2" className="lead">
            {polyglot.t(message)}
          </Typography>
        </Alert>
      </Box>
    </AuthLayout>
  );
};
